/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CaseInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import CaseNumber from './CaseNumber'
import {
  caseNumberAction,
  paymentAmountAction,
  clearAllAction,
  screenLoadingAction,
  addCaseAction,
  clearCaseAction,
  paymentAmountFullAction,
  minPaymentAmountAction,
  amountOwingAction,
  caseSotIdAction,
  receiptDetailAction,
  caseTypeAction,
} from 'redux/actions'
import { registerAndLogin } from 'redux/reducers/apiReducers/registerReducer'
import { logoutAction } from 'redux/reducers/apiReducers/authenticationReducer'
import { getCaseOweAmountAction } from 'redux/reducers/apiReducers/caseOweAmountReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
import PrivacyStatement from './PrivacyStatement'
import BackAnchor from '../../../../shared/components/BackAnchor'
import axios from 'axios'
import moment from 'moment'

const CaseInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [isHelperOpen, setIsHelperOpen] = useState(false)
  const [caseNumberValid, setCaseNumberValid] = useState('')
  const [confirmCaseNumberValid, setConfirmCaseNumberValid] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [caseNumberError, setCaseNumberError] = useState('case_information.case_number_error')
  const [caseNumberJEINError, setCaseNumberJEINError] = useState('')
  const [confirmCaseNumberError, setConfirmCaseNumberError] = useState('case_information.confirm_case_number_error')

  const { caseNumber, cases } = useSelector((state) => state.app)
  const [showPrivacyStatement, setShowPrivacyStatement] = useState(false)

  const [disableFlag, setDisableFlag] = useState(false)
  const [serviceFlag, setServiceFlag] = useState(false)

  const outageUrl = window.location.origin + '/services/outageservice/api/outage-events'

  const [outageStartDate, setOutageStartDate] = useState('')
  const [outageEndDate, setOutageEndDate] = useState('')
  const [outageActive, setOutageActive] = useState(false)
  const [outageRichTexts, setOutageRichTexts] = useState([])

  const warnEventUrl = window.location.origin + '/services/outageservice/api/warning-events'

  const [warningFlag, setWarningFlag] = useState(false)
  const [warningActive, setWarningActive] = useState(false)
  const [warningRichTexts, setWarningRichTexts] = useState([])
  const [warningServiceFlag, setWarningServiceFlag] = useState(false)
  const [warningStartDate, setWarningStartDate] = useState('')
  const [warningEndDate, setWarningEndDate] = useState('')

  const dateNow = moment().toDate()
  const [dateFlag, setDateFlag] = useState(false)

  const backNextProps = {
    prevText: t('case_information.back'),
    // prevURL: `/${i18n.language}${t('routes.privacy_notice')}`,
    prevURL:
      i18n.language === 'fr'
        ? 'https://beta.novascotia.ca/fr/faire-un-paiement-de-dedommagement'
        : 'https://beta.novascotia.ca/make-restitution-payment',
    nextText: t('case_information.next'),
  }

  const onAddCase = () => {
    try {
      if (checkCookiesEnabled()) {
        if (validateFields()) {
          setErrMsg('')
          dispatch(screenLoadingAction())
          dispatch(getServiceAvailableAction())
            .then((res) => {
              if (res['data']) {
                dispatch(registerAndLogin())
                  .then(() => {
                    dispatch(getCaseOweAmountAction({ caseNumber: caseNumber }))
                      .then((res) => {
                        if (
                          !res['validationFailureMessage'] &&
                          !isNaN(res['amountOwing']) &&
                          res['amountOwing'].toString().indexOf('.') !== -1
                        ) {
                          handleCaseProcess(res)
                          // if (res['paymentAdjustmentMessage'] && res['paymentAdjustmentMessage'].includes('Full payment must be made.')) {
                          //   processPaymentFullCase(res)
                          // } else {
                          //   caseNotFullProcess(res)
                          // }
                        } else {
                          setCaseNumberValid(false)
                          setCaseNumberJEINError(
                            i18n.language === 'en' ? res['validationFailureMessage'] : res['validationFailureMessageFr']
                          )
                        }
                        dispatch(screenLoadingAction())
                      })
                      .catch((e) => {
                        setCaseNumberValid(false)
                        setCaseNumberError('case_information.service_not_available_error')
                        console.log(e)
                        dispatch(screenLoadingAction())
                      })
                  })
                  .catch((e) => {
                    dispatch(screenLoadingAction())
                    console.log(e)
                    setErrMsg('privacy_notice.server_error')
                  })
              } else {
                setErrMsg('case_information.service_not_available_error')
                dispatch(screenLoadingAction())
              }
            })
            .catch((e) => {
              console.log(e)
              setErrMsg('case_information.service_not_available_error')
              dispatch(screenLoadingAction())
            })
        }
      }
    } catch (e) {
      console.log(e)
      setCaseNumberValid(false)
      setCaseNumberError('case_information.service_not_available_error')
    }
  }

  // const processPaymentFullCase = (res) => {
  //   try {
  //     dispatch(
  //       addCaseAction({
  //         caseNumber,
  //         amountOwing: res['amountOwing'],
  //         paymentAmount: res['amountOwing'],
  //         minPaymentAmount: res['minimumPaymentAmount'],
  //         paymentAmountFull: 'final',
  //         caseSotId: res['caseSotId'],
  //         receiptDetail: res['receiptDetail'],
  //         caseType: res['caseSotValue'],
  //       })
  //     )
  //     dispatch(clearCaseAction())
  //     dispatch(editCaseNumberAction(''))
  //     history.push(`/${i18n.language}${t('routes.listed_cases')}`)
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }

  // const caseNotFullProcess = (res) => {
  //   dispatch(amountOwingAction(res['amountOwing'].toString()))
  //   dispatch(minPaymentAmountAction(res['minimumPaymentAmount'].toString()))
  //   dispatch(caseTypeAction(res['caseSotValue']))
  //   dispatch(receiptDetailAction(res['receiptDetail']))
  //   dispatch(caseSotIdAction(res['caseSotId']))
  //   history.push(`/${i18n.language}${t('routes.case_owing_info')}`)
  // }

  const handleCaseProcess = (res) => {
    if (res['paymentAdjustmentMessage'] && res['paymentAdjustmentMessage'].includes('Full payment must be made.')) {
      dispatch(
        addCaseAction({
          caseNumber,
          amountOwing: res['amountOwing'],
          paymentAmount: res['amountOwing'],
          minPaymentAmount: res['minimumPaymentAmount'],
          paymentAmountFull: 'final',
          caseSotId: res['caseSotId'],
          receiptDetail: res['receiptDetail'],
          caseType: res['caseSotValue'],
        })
      )
      dispatch(paymentAmountFullAction('final'))
    } else {
      dispatch(paymentAmountFullAction(''))
    }
    dispatch(amountOwingAction(res['amountOwing'].toString()))
    dispatch(minPaymentAmountAction(res['minimumPaymentAmount'].toString()))
    dispatch(caseTypeAction(res['caseSotValue']))
    dispatch(receiptDetailAction(res['receiptDetail']))
    dispatch(caseSotIdAction(res['caseSotId']))
    history.push(`/${i18n.language}${t('routes.case_owing_info')}`)
  }

  const validateFields = () => {
    try {
      let isCaseNumberValid = false
      if (caseNumber === '') {
        setCaseNumberValid(false)
      } else {
        isCaseNumberValid = validateCaseNumber(caseNumber)
      }
      return isCaseNumberValid
      // validateConfirmCaseNumber(confirmCaseNumber)
      // if (confirmCaseNumber === '') {
      //   setConfirmCaseNumberValid(false)
      // }
      // return (
      //   caseNumberValid === true &&
      //   confirmCaseNumberValid === true &&
      //   caseNumber !== '' &&
      //   confirmCaseNumber !== '' &&
      //   caseNumber === confirmCaseNumber
      // )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateCaseExist = (caseData) => {
    try {
      return cases.find((caseInfo) => caseInfo.caseNumber === caseData)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateCaseNumber = (caseNumber) => {
    let isCaseNumberValid = false,
      errorMessage = ''
    try {
      setCaseNumberJEINError('')
      const regex = RegExp(/^\d+$/)
      if (caseNumber !== '') {
        if (regex.test(caseNumber)) {
          if (caseNumber.length > 0) {
            if (validateCaseExist(caseNumber)) {
              errorMessage = 'case_information.case_number_exist'
            } else {
              isCaseNumberValid = true
            }
          } else {
            errorMessage = 'case_information.case_number_less'
          }
        } else {
          errorMessage = 'case_information.case_number_invalid'
        }
      } else {
        errorMessage = 'case_information.case_number_error'
      }
      setCaseNumberValid(isCaseNumberValid)
      setCaseNumberError(errorMessage)
      return isCaseNumberValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const togglePrivacyStatement = useCallback((e) => {
    e.preventDefault()
    setShowPrivacyStatement((prevState) => !prevState)
  }, [])

  const privacyToggleIcon = useMemo(() => (showPrivacyStatement ? 'fa-minus' : 'fa-plus'), [showPrivacyStatement])

  const sendGetRequest = async () => {
    try {
      const res = await axios.get(outageUrl)
      const events = res.data
      const now = moment().toDate()
      const activeTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYRESTITUTION') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.outageStart).toDate()
        const endDate = moment(event.outageEnd).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeTexts.push(event.outageRichText)
          setOutageActive(true)
          setServiceFlag(true)
          setDateFlag(true)
          setDisableFlag(true)
        }
      }
      setOutageRichTexts(activeTexts)
    } catch (err) {
      console.error(err)
    }
  }

  const sendWarnGetRequest = async () => {
    try {
      const res = await axios.get(warnEventUrl)
      const events = res.data
      const now = moment().toDate()
      const activeWarnTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYRESTITUTION') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.warningStartDate).toDate()
        const endDate = moment(event.warningEndDate).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeWarnTexts.push(event.warningMessageText)
          setWarningActive(true)
          setWarningServiceFlag(true)
          setWarningFlag(true)
        }
      }
      setWarningRichTexts(activeWarnTexts)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    sendGetRequest()
    sendWarnGetRequest()
  }, [])

  const momentOutageStartDate = moment(outageStartDate).toDate()
  const momentOutageEndDate = moment(outageEndDate).toDate()
  const momentWarningStartDate = moment(warningStartDate).toDate()
  const momentWarningEndDate = moment(warningEndDate).toDate()

  useEffect(() => {
    if (dateNow > momentOutageStartDate && dateNow < momentOutageEndDate) {
      setDateFlag(true)
    }
  }, [momentOutageStartDate, momentOutageEndDate])

  useEffect(() => {
    if (dateNow > momentWarningStartDate && dateNow < momentWarningEndDate) {
      setWarningFlag(true)
    }
  }, [momentWarningStartDate, momentWarningEndDate])

  useEffect(() => {
    if (dateFlag && serviceFlag && outageActive) {
      // flag = true
      setDisableFlag(true)
      // console.log(flag)
    }
  }, [dateFlag, serviceFlag, outageActive])

  window.onload = function () {
    dispatch(clearAllAction())
  }

  const [prevPage, setPrevPage] = useState('')

  useEffect(() => {
    try {
      const addAnotherCaseClicked = localStorage.getItem('addAnotherCaseClicked')
      if (addAnotherCaseClicked === 'casePayment') {
        setPrevPage('routes.case_owing_info')
        dispatch(clearCaseAction())
      } else if (addAnotherCaseClicked === 'reviewConfirm') {
        setPrevPage('routes.review_confirmation')
        dispatch(clearCaseAction())
      } else {
        dispatch(clearAllAction())
        localStorage.removeItem('addAnotherCaseClicked')
        dispatch(logoutAction()).catch((e) => {
          console.error('Logout failed:', e)
        })
      }
    } catch (e) {
      console.error('Unexpected error in useEffect:', e)
      setIsError(true)
    }
  }, [])

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled
      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
        if (cookieEnabled) {
          return true
        } else {
          setErrMsg('privacy_notice.enable_cookies')
        }
      }
      return cookieEnabled
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  function Banner() {
    if (disableFlag === true) {
      return (
        <>
          {outageRichTexts.map((text, index) => (
            <div key={index} className="alert-medium" data-gtm-vis-first-on-screen-9622674_25="908" data-gtm-vis-total-visible-time-9622674_25="100" data-gtm-vis-has-fired-9622674_25="1" data-gtm-vis-first-on-screen-9622674_29="912" data-gtm-vis-total-visible-time-9622674_29="100" data-gtm-vis-has-fired-9622674_29="1">
              <p className="no-margin"><span>{text}</span></p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  function WarningBanner() {
    if (warningFlag === true && disableFlag === false && warningServiceFlag === true && warningActive === true) {
      return (
        <>
          {warningRichTexts.map((text, index) => (
            <div key={index} className="alert-medium" data-gtm-vis-first-on-screen-9622674_25="908" data-gtm-vis-total-visible-time-9622674_25="100" data-gtm-vis-has-fired-9622674_25="1" data-gtm-vis-first-on-screen-9622674_29="912" data-gtm-vis-total-visible-time-9622674_29="100" data-gtm-vis-has-fired-9622674_29="1">
              <p className="no-margin"><span>{text}</span></p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  const handleContinueAction = () => {
    if (localStorage.getItem('addAnotherCaseClicked') === 'casePayment') {
      const lastCase = cases[cases.length - 1]
      dispatch(caseNumberAction(lastCase.caseNumber))
      dispatch(amountOwingAction(lastCase.amountOwing))
      dispatch(paymentAmountAction(lastCase.paymentAmount))
      dispatch(minPaymentAmountAction(lastCase.minPaymentAmount))
      dispatch(caseTypeAction(lastCase.caseType))
      dispatch(receiptDetailAction(lastCase.receiptDetail))
      dispatch(caseSotIdAction(lastCase.caseSotId))
    }
    history.push(`/${i18n.language}${t(prevPage)}`)
  }

  // const validateConfirmCaseNumber = (number) => {
  //   try {
  //     if (number && number === caseNumber) {
  //       setConfirmCaseNumberValid(true)
  //     } else {
  //       setConfirmCaseNumberValid(false)
  //       setConfirmCaseNumberError('case_information.confirm_case_number_error')
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }

  return (
    <div className="container">
      <BackAnchor
        isInternal={false}
        backPath={
          i18n.language === 'fr'
            ? 'https://beta.novascotia.ca/fr/faire-un-paiement-de-dedommagement'
            : 'https://beta.novascotia.ca/make-restitution-payment'
        }
      />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <Banner />
          <WarningBanner />
          <h2>{t('case_information.tell_us_about')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <p>{t('case_information.more_about')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <p>
            <a
              href="https://support.novascotia.ca/restitution/payments?_ga=2.158293561.2094819447.1747744345-574972600.1739459229"
              target="_blank"
            >
              {t('case_information.read_more')}
            </a>
            {t('case_information.open_new_tab')}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <CaseNumber
            validateCaseNumber={validateCaseNumber}
            caseNumberError={caseNumberError}
            caseNumberValid={caseNumberValid}
            caseNumberJEINError={caseNumberJEINError}
            setIsError={setIsError}
          />
          {/* <ConfirmCaseNumber
              validateConfirmCaseNumber={validateConfirmCaseNumber}
              confirmCaseNumberError={confirmCaseNumberError}
              confirmCaseNumberValid={confirmCaseNumberValid}
              setIsError={setIsError}
            /> */}
        </div>
      </div>
      {/* <div className="row">
          <div className="col-xs-12 col-lg-8">
            <div className="help-field">
              <a className="cases_not_sure" tabIndex="0" onClick={() => setIsHelperOpen(!isHelperOpen)}>
                {t('case_information.where_do_find')}
                <i
                  className={[isHelperOpen ? 'fas fa-minus fa-sm' : 'fas fa-plus fa-sm', styles['exclamation_margin_left']].join(' ')}
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            {isHelperOpen && (
              <div className={styles['helper_content']}>
                <blockquote className={styles['blockquote_font']}>
                  <p>
                    {t('case_information.restitution_case_numbers_can_be')}
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        i18n.language === 'en'
                          ? 'https://support.novascotia.ca/restitution/payments'
                          : 'https://support.novascotia.ca/restitution/payments-fr'
                      }
                    >
                      {t('case_information.read_more_and_find')}
                      <span className="ns-visually-hidden">(opens in a new tab)</span>
                    </a>
                    .
                  </p>
                </blockquote>
              </div>
            )}
          </div>
        </div> */}
      <div className={styles['error_margin']} style={{ gap: '20px' }}>
        <BackNextButtons props={backNextProps} nextOnClick={onAddCase} displayBack={false} />
        {cases.length > 0 && (
          <button className={['btn-lg btn-default-transparent']} style={{ margin: 0 }} onClick={handleContinueAction}>
            {t('case_information.continue_without_adding_case')}
          </button>
        )}
      </div>
      {errMsg && (
        <div className={styles['error_message']}>
          <div className="form-group has-error">
            <div className="help-block">{t(errMsg)}</div>
          </div>
        </div>
      )}

      <div className="row" style={{ marginBottom: '2rem' }}>
        <div className="col-xs-12 col-lg-8">
          <hr />
          <br />
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <i
              onClick={togglePrivacyStatement}
              aria-label={t('shared.error')}
              className="fa fa-lock fa-lg"
              aria-hidden="true"
              style={{ color: '#0058a4', marginTop: '3px' }}
            ></i>
            <a href="#" id="toggle-privacy-statement" onClick={togglePrivacyStatement}>
              {t('privacy_notice.how_we_protect_information')}
            </a>
            <i
              onClick={togglePrivacyStatement}
              aria-label={t('shared.error')}
              className={`fa fa-lg ${privacyToggleIcon}`}
              aria-hidden="true"
              style={{ color: '#0058a4', marginTop: '3px' }}
            ></i>
          </div>
          {showPrivacyStatement && <PrivacyStatement />}
          <br />
          <hr />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(CaseInformationView)
